// @flow
/** @jsx jsx */

import React from 'react';
import { jsx } from '@emotion/core';
import { useMobileMediaQuery } from '../config/mediaQuery';

const headerHeight = 80;

const getMinHeight = (props, isMobile, savedOrders = false) => {
  if (props.isFullPage && !props.active) return { display: 'none' };

  if (props.size !== undefined) {
    switch (props.size) {
      case 'small':
        return { minHeight: '350px' };
      default:
        return { minHeight: '600px' };
    }
  }

  if (props.isFullPage && !isMobile) {
    return { height: `calc(100vh - ${headerHeight}px)` };
  } else if (props.isFullPage && isMobile && !savedOrders) {
    return { height: `calc(100vh - ${180}px)` };
  } else if (props.isFullPage && isMobile && savedOrders) {
    return {  height: `calc(100vh - ${160}px)` };
  }

  return { minHeight: '600px' };
};

// $FlowFixMe
const PageContainer = React.forwardRef((props, ref) => {
  const { className } = props;

  const isMobile = useMobileMediaQuery();
  return (
    <div
      ref={ref}
      css={[
        {
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        },
        getMinHeight(props, isMobile, props.savedOrders),
        props.isFullPage && {
          width: '100vw',
        }
      ]}
      className={className}
    >
      {props.children}
    </div>
  );
});

export default PageContainer;
